module.exports = __webpack_public_path__ + "img/bg14.312d6e46.svg";